import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TApplication, TApplicationPayloadRequest, TApplicationResponse, adaptApplicationFromResponse, adaptApplicationToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_APPLICATION } from '../../backend-paths';


export const applicationCreateApi = createAsyncThunk(
	`POST/${BACKEND_ADMIN_APPLICATION}`,
	(payload: TApplicationPayloadRequest, thunkApi) => {
		const dataRequest = adaptApplicationToRequest(payload);

		return HttpService.post<TApplicationResponse>(BACKEND_ADMIN_APPLICATION, dataRequest).then(result => {
			return adaptApplicationFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TApplication> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const applicationCreateSlice = createSlice({
	name: 'applicationCreateSlice',
	initialState,
	reducers: {
		clearApplicationCreate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[applicationCreateApi.pending.type]: (state) => {
			state.error = undefined;
			state.isLoading = true;
		},

		[applicationCreateApi.fulfilled.type]: (state, action: PayloadAction<TApplication>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[applicationCreateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const useApplicationCreateSelector = () => useAppSelector(state => state[applicationCreateSlice.name]);

export const { clearApplicationCreate } = applicationCreateSlice.actions;
